import { getJavaRequest } from "@tipico/java-streams";
import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Subscription } from "rxjs";
import screenToRoute from "../screenToRoute";
import NavigationEventDTO from "./NavigationEventDTO";

export class JavaNavigationHandler extends React.Component<
    RouteComponentProps
> {
    private navigationSubscription: Subscription = new Subscription();

    public componentDidMount() {
        this.navigationSubscription.add(
            getJavaRequest<NavigationEventDTO>("Navigation").subscribe(
                destination => {
                    this.props.history.push({
                        pathname: screenToRoute(destination.route),
                        search: this.extractParams(destination.parameters)
                    });
                }
            )
        );
    }

    public componentWillUnmount() {
        this.navigationSubscription.unsubscribe();
    }

    public render() {
        return this.props.children;
    }

    private extractParams(params: { [key: string]: string }) {
        if (!params || Object.keys(params).length === 0) {
            return "";
        }
        return Object.keys(params)
            .map(key => key + "=" + params[key])
            .reduce(
                (acc: string, paramKeyValue: string) =>
                    acc + "&" + paramKeyValue
            );
    }
}

export default withRouter(JavaNavigationHandler);
